export default __webpack_public_path__ + "static/media/maxresdefault-1727910846055.af2ab966.jpg";